import React from 'react'
import Intro from '../Intro/Intro'
import './Home.css'

const Home = () => {
  return (
    <section className='inner'>
      <div className='container'>
      <Intro />
      </div> 
    </section>
  )
}

export default Home

